import Routers from './router'
import contractStore from './store'
export default{
	install(Vue,{router,store}){
		router.addRoute(Routers);
		store.registerModule('contractModule', contractStore)
	}
}